module.exports = __webpack_public_path__ + "static/img/img_guanli_jiejue_fangan.9f117395.png";